import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var MathSolver = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement(SvgFill, {
    d: "M0 13.638C0 8.64 4.102 4.543 9.105 4.543h20.312c.6 0 1 .5 1 1s-.5.999-1 .999H9.105c-3.902 0-7.104 3.198-7.104 7.096v21.687c0 3.898 3.202 7.096 7.104 7.096h21.712c3.903 0 7.105-3.198 7.105-7.096V23.132c0-.6.5-1 1-1s1 .5 1 1v12.193c0 4.997-4.102 9.095-9.104 9.095H9.104C4.102 44.42 0 40.322 0 35.325V13.638Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M30.217 30.728c.4.4.4 1 0 1.399-.4.4-1 .4-1.4 0l-2.702-2.698-2.702 2.698c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l2.701-2.797-2.701-2.799c-.4-.4-.4-1 0-1.4.4-.399 1.1-.399 1.4 0l2.702 2.7 2.601-2.7c.4-.399 1-.399 1.401 0 .4.4.4 1 0 1.4l-2.701 2.799 2.801 2.798Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M17.71 15.936c.2-.4.5-.6.9-.6h12.207c.6 0 1.001.5 1.001 1 0 .6-.5 1-1 1H19.31l-6.504 15.59c-.2.4-.6.6-1 .6s-.8-.3-.9-.7l-2.702-9.394c-.2-.5.2-1.1.7-1.3.5-.2 1.1.2 1.3.7l1.902 6.697 5.603-13.593ZM43.925 8.64l-6.504 10.894c-.2.4-.8.6-1.2.4-.5-.2-.7-.6-.7-1.1l.9-6.695h-2.902c-.6 0-1-.5-1-1 0-.2.1-.4.2-.5L38.822.945c.2-.4.7-.6 1.2-.5.401.2.701.6.701 1l-.5 5.597h2.801c.4 0 .7.2.901.5.1.399.1.799 0 1.099Z"
  })));
});
MathSolver.displayName = 'MathSolver';
MathSolver.defaultProps = {
  'aria-label': 'MathSolver'
};
export default MathSolver;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/MathSolver.js
// module id = 3204
// module chunks = 11